export const APPOINTMENT_NOTIFICATION_TYPES = Object.freeze([
  'appointment_created',
  'appointment_reminder',
  'appointment_modified_by_client',
  'appointment_modified_by_manager',
  'appointment_manual_request',
  'appointment_confirmed',
  'appointment_modified_confirmed',
  'appointment_reassigned',
  'appointment_proposal_created',
  'appointment_proposal_accepted',
  'appointment_proposal_cancelled',
  'appointment_proposal_expired',
  'appointment_cancelled_by_salon',
]);

const appointmentNotificationTypeSet = new Set(APPOINTMENT_NOTIFICATION_TYPES);

const hasIdentifier = (value) =>
  value !== undefined && value !== null && value !== '';

export const isAppointmentNotification = (notification) =>
  appointmentNotificationTypeSet.has(notification?.type);

export const getAppointmentNotificationPath = (
  notification,
  { isProfessionalUser = false, isClientUser = false } = {},
) => {
  const appointmentId = notification?.data?.appointment_id;
  if (!isAppointmentNotification(notification) || !hasIdentifier(appointmentId)) {
    return null;
  }

  const encodedId = encodeURIComponent(String(appointmentId));
  if (isProfessionalUser) {
    return `/pro/rendez-vous?appointmentId=${encodedId}`;
  }
  if (isClientUser) {
    return `/client/appointments/${encodedId}`;
  }
  return null;
};

export const isProfessionalAppointmentNotification = (
  notification,
  isProfessionalUser,
) => Boolean(isProfessionalUser && isAppointmentNotification(notification));

export const getProfessionalAppointmentNotificationPath = (
  notification,
  isProfessionalUser,
) =>
  getAppointmentNotificationPath(notification, {
    isProfessionalUser,
    isClientUser: false,
  });

export const APPOINTMENT_NOT_FOUND_ERROR_KEY =
  'appointment_workflow.errors.appointment_not_found';

export const resolveAppointmentDeepLink = (appointments, rawAppointmentId) => {
  if (!Array.isArray(appointments) || !hasIdentifier(rawAppointmentId)) {
    return { appointment: null, errorKey: null };
  }

  const targetId = String(rawAppointmentId);
  const appointment = appointments.find((item) => {
    const id = item?.appointment_id ?? item?.id ?? item?.pk;
    return hasIdentifier(id) && String(id) === targetId;
  });

  if (!appointment) {
    return {
      appointment: null,
      errorKey: APPOINTMENT_NOT_FOUND_ERROR_KEY,
    };
  }

  return { appointment, errorKey: null };
};
